// dependencies
import React from "react";
import PropTypes from "prop-types";
import NextLink from "next/link";
import { StyleSheet } from "aphrodite";

// components
import { IconMapMarker } from "@cloudspire/legacy-svg-icon-library";
import Text from "@cloudspire/legacy-resources/src/components/Text2";

const styles = StyleSheet.create({
  link: {
    textDecoration: "none",
  },
});

function RoomAddress(props) {
  const { zipcode, city, href } = props;

  if (href) {
    return (
      <NextLink href={href} passHref legacyBehavior>
        <Text as="a" aStyle={styles.link}>
          <IconMapMarker />
          &nbsp;{city} ({zipcode})
        </Text>
      </NextLink>
    );
  }

  return (
    <Text as="a" aStyle={styles.link}>
      <IconMapMarker />
      &nbsp;{city} ({zipcode})
    </Text>
  );
}

RoomAddress.propTypes = {
  zipcode: PropTypes.any,
  city: PropTypes.string,
  href: PropTypes.string,
};

export default RoomAddress;
